import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import Box from "@mui/material/Box";
import { useCsCfgObject, } from "@plansoft-configuration-renderer/framework";
import { useTranslatorWithInterpolation } from "@plansoft-configuration-renderer/localization";
import { CommonComponentsContext } from "../Common/CommonComponents";
/**
 * Displays info text on configuration level
 * @param props
 * @returns
 */
export function ConfigurationInfoText(props) {
    const { dictionaryKey, fallbackText = "", textMode = "plaintext" } = props;
    if (!dictionaryKey) {
        return _jsx(Fragment, {});
    }
    return (_jsx(Box, { children: _jsx(ConfigurationInfoTextTranslation, { dictionaryKey: dictionaryKey, fallbackText: fallbackText, textMode: textMode }) }));
}
export function ConfigurationInfoTextTranslation(props) {
    const cfgObject = useCsCfgObject();
    const { dictionaryKey, fallbackText } = props;
    const { Markdown } = useContext(CommonComponentsContext);
    const translate = useTranslatorWithInterpolation();
    const text = translate(dictionaryKey, fallbackText, Object.assign({}, cfgObject.variables));
    if (props.textMode === "markdown") {
        return _jsx(Markdown, { src: text });
    }
    return _jsx(Fragment, { children: text });
}
//# sourceMappingURL=ConfigurationInfoText.js.map